<wiz-vgroup #vgDetailZone width="100%" height="100%" horizontalAlign="center" gap="2" padding="5px" class="section-container">
  <wiz-hgroup width="100%" verticalAlign="center" padding="3px">
    <wiz-label #lbTitle width="100%" class="smallTitleLabel"></wiz-label>
    <wiz-icon class="image-purple" (click)="doCancel()">close</wiz-icon>
  </wiz-hgroup>

  <!-- nom du champ et formule -->
  <wiz-vgroup #gpContent visible="false" verticalAlign="center" height="40px" width="100%" class="section-container" padding="5px">
    <wiz-label #lbContent width="100%" height="100%" padding="3px" class="listItemFont"></wiz-label>
  </wiz-vgroup>


  <!-- libellé -->
  <wiz-vgroup #gpHeader id="gpHeader" verticalAlign="center" width="100%" class="section-container" padding="5px" gap="0">
    <wiz-label [wizLabel]="'$.chart.setting.legend.$'" class="smallTitleLabel"></wiz-label>
    <wiz-hgroup width="100%">
      <wiz-text-input #tiLabel width="120px" [wizLabel]="'$.common.label.$'" [wizMaxChars]="50"> </wiz-text-input>
    </wiz-hgroup>
  </wiz-vgroup>

  <!-- gestion du format de données, du champ en cas de FD, et de la fonction d'aggregat -->
  <wiz-vgroup #gpFormat verticalAlign="center" width="100%" class="section-container" padding="5px" gap="0">
    <wiz-label [wizLabel]="'$.chart.setting.value.$'" class="smallTitleLabel"></wiz-label>
    <wiz-hgroup width="100%" verticalAlign="center">
      <wiz-dropdown
        #ddFormat
        width="150px"
        [wizLabelField]="'trsLabel'"
        [wizLabel]="'$.pivot.edit.field.format.$'"></wiz-dropdown>
      <wiz-dropdown [visible]="false"
        #ddField id="ddField"
        width="150px"
        [wizLabelField]="'trsLabel'"
        [wizLabel]="'$.pivot.edit.field.field.$'"></wiz-dropdown>
        <wiz-dropdown [visible]="false" id="ddChronoField"
        #ddChronoField
        width="150px"
        [wizLabelField]="'trsLabel'"
        [wizLabel]="'$.pivot.edit.field.field.$'"></wiz-dropdown>
      <wiz-dropdown
        #ddFunc
        width="150px"
        [wizLabelField]="'fullName'"
        [wizLabel]="'$.pivot.edit.field.agg.method.$'"
        wizPanelWidth="250px"
      ></wiz-dropdown>

      <wiz-dropdown
      #ddStyle id="ddStyle"
      width="150px"
      [wizDataProvider] = "styleDS"
      [wizLabelField]="'code'"
      [wizLabel]="'$.pivot.edit.field.condstyle.$'"></wiz-dropdown>

    </wiz-hgroup>
  </wiz-vgroup>

  <wiz-spacer height="100%"></wiz-spacer>
  <wiz-hgroup width="100%" height="45px" padding="5px" horizontalAlign="end">
    <wiz-button
      #btnSave
      [wizLabel]="'$.common.save.modification.$'"
      [wizIcon]="'icon-arrow-right'"
      (click)="save()"
      [iconPlacement]="'right'"
    ></wiz-button>
    <wiz-button
      #btnCancel
      class="cancel-button"
      [wizIcon]="'icon-arrow-left'"
      (click)="doCancel()"
      [wizLabel]="'$.common.cancel.modification.$'"
    ></wiz-button>
  </wiz-hgroup>
</wiz-vgroup>
